import Guard from '@/services/middleware'
import Users from './Users'
import Busine from './Busine'
import SurveySatisfaction from './SatisfactionSurvey'
import Integrations from './Integrations'
import Department from './Department'
import Logs from './Logs'
import Configurations from './Configurations'
import AttendanceCategory from './AttendanceCategory'
import Library from './Library'
import Actions from './Actions'
import InternalChat from './InternalChat'
import Webhooks from './Webhooks'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const HomeSettings = () => import('@/views/dash/settings/Home.vue')

export default [
    {
        path: '/ajustes',
        component: DashLayout,
        meta: { title: 'Ajustes', permission: 2,  module: 'config_system'},
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
        children: [
            { path: '', name: 'settings.home', component: HomeSettings},
            ...SurveySatisfaction, // ok
            ...Department, // ok
            ...Users, // ok
            ...Integrations, // ok
            ...Logs, // ok
            ...Configurations,
            ...AttendanceCategory,
            ...Busine,
            ...Library,
            ...Actions,
            ...InternalChat, // ok
            ...Webhooks,
        ],
    },
]